import React from 'react';
import { Helmet } from 'react-helmet-async';

import AnalysisComponent from '../app-rationalization/ARAnalysis/AnalysisComponent';

const Analysis = () => (
    <>
      <Helmet>
        <title> Dashboard: Analysis Page</title>
      </Helmet>

      <AnalysisComponent />
    </>
  );

export default Analysis;
